/* eslint-disable unused-imports/no-unused-vars-ts */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { appConfig } from "../constant/app.constant";
import { GetAddressRequest } from "../models/get-address-request";
import { GetAddressessResponse } from "../models/get-address-response";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class AddressService {
  private baseUrl = `${appConfig.BASE_URL}ReturnPortalFacade`;

  constructor(private httpClient: HttpClient) {}

  getAddress(request: GetAddressRequest): Observable<GetAddressessResponse> {
    const params = new HttpParams()
      .set('senderCode', request.senderCode)
      .set('carrierCode', request.carrierCode)
      .set('carrierServiceCode', request.carrierServiceCode);

    if (request.masterSenderCode) params.set('masterSenderCode', request.masterSenderCode);
    if (request.isoCountryCode) params.set('isoCountryCode', request.isoCountryCode);
    if (request.carrierAccountNumber) params.set('carrierAccountNumber', request.carrierAccountNumber);

    return this.httpClient.get<GetAddressessResponse>(`${this.baseUrl}/GetAddress`, { params });
  }

}
